<template>
    <div>
        <div class="rechargecontent" id="main">
            <p class="rechargecenter">充值中心</p>
            <p class="canused">账户当前可用余额</p>
            <p class="record">{{userInfo.balance}} 元</p>
            <el-divider></el-divider>
            <p class="selecttext">选择充值金额：</p>
            <div class="selectcontent">
                <div
                    class="pay"
                    v-for="(item,index) in payArr"
                    :key="index"
                    @click="handleclickpay(item.num)"
                    :class="{'aaa': paynum == item.num}"
                >{{item.num}}元</div>
            </div>
            <div class="shouldpaycontent">
                <p class="shouldpay">应支付金额：</p>
                <p class="paynum">{{paynum}}元</p>
            </div>
            <el-divider></el-divider>
            <p class="paymethods">选择支付方式：</p>
            <div class="paycontent">
                <el-button round :class="{'pay': way == 1}" @click="payWx">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-wx-tx" />
                    </svg>
                    微信支付
                </el-button>
                <el-button round @click="payCreate" :class="{'pay': way == 2}">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-zfbzf" />
                    </svg>
                    支付宝支付
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import { baseUrl } from '../../config';
    export default {
        data() {
            return {
                record: '0.00',
                payArr: [
                    { num: 20 },
                    { num: 50 },
                    { num: 100 },
                    { num: 200 },
                    { num: 500 },
                    { num: 1000 }
                ],
                paynum: 20,
                way: 2
            };
        },
        created() {
            this.userInfo = this.$store.state.login.userInfo;
        },
        methods: {
            handleclickpay(num) {
                this.paynum = num;
            },
            payWx() {
                // this.way = 1;
                this.$message('暂未开通微信支付');
            },
            payCreate() {
                this.way = 2;
                this.$confirm('将要前往支付页面，是否确认？', '支付提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '去支付',
                    cancelButtonText: '放弃',
                    center: true
                })
                    .then(() => {
                        this.httpPost(this.$root.payCreate, {
                            way: this.way,
                            target_id: 0,
                            target_type: 3,
                            money: this.paynum
                        })
                            .then(result => {
                                let token = this.$store.state.login.token;
                                location.href =
                                    baseUrl +
                                    '/pay/confirm?pay_id=' +
                                    result.id +
                                    '&token=' +
                                    token;
                            })
                            .catch(err => {
                                console.error('payCreate-err', err);
                            });
                    })
                    .catch(action => {
                        this.$message({
                            type: 'info',
                            message: '支付取消'
                        });
                    });
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .rechargecontent {
        margin: auto;
        background-color: white;
        padding: 32px 100px;

        .rechargecenter {
            font-size: 16px;
            color: #666666;
        }

        .canused {
            font-size: 14px;
            margin-top: 100px;
            text-align: center;
        }

        .record {
            font-size: 30px;
            color: #E6A23C;
            text-align: center;
        }

        .selecttext {
            margin-top: 20px;
        }

        .selectcontent {
            flex-x(flex-start, space-around);
            flex-wrap: wrap;
            margin-top: 23px;

            .pay {
                width: 132px;
                height: 50px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                border: 1px solid rgba(232, 232, 232, 1);
                width: 132px;
                font-size: 20px;
                color: rgba(153, 153, 153, 1);
                line-height: 26px;
                margin: 10px 17px;
                flex-center();
            }

            .aaa {
                border-style: solid;
                border-width: 1px;
                border-color: #E6A23C;
                color: #E6A23C;
                font-size: 20px;
            }
        }

        .shouldpaycontent {
            display: flex;
            flex-direction: row;
            margin-top: 50px;

            .paynum {
                font-size: 18px;
                color: #E6A23C;
            }
        }

        .paycontent {
            display: flex;
            flex-direction: row;
            margin: 22px 0;
            flex-x(center);

            svg {
                width: 16px;
                height: 16px;
                margin-right: 12px;
            }

            .primary {
                margin-top: 16px;
                width: 100px;
                height: 36px;
            }

            .pay {
                border: 1px solid rgba(230, 162, 60, 1);
            }
        }

        .submit {
            margin-top: 138px;
            margin-left: 800px;
        }
    }
</style>
